import React from "react";
import { HiOutlineAnnotation } from "react-icons/hi";
import { space, color } from "styled-system";
import styled from "styled-components";

const StyledIcon = styled(HiOutlineAnnotation).attrs((props) => ({
  size: props.size,
}))((props) => props.styles, space, color);

const BotIcon = (props) => {
  return <StyledIcon {...props} />;
};

BotIcon.defaultProps = {
  size: 22,
  styles: {},
};

export default BotIcon;
